"use client";

import React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function TheStandardOfLuxury() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="264345" id="the-standard-of-luxury" className="text-foreground py-16 md:py-24 lg:py-32 bg-background light">
      <div ref={ref} className={`page-container transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 lg:gap-24 mb-20 lg:mb-32">
          <div className="flex flex-col gap-4">
            <h3 className="text-2xl md:text-3xl font-bold font-default text-foreground uppercase tracking-wider pl-4 md:pl-12">QUALITY CRAFTSMANSHIP</h3>
            <p className="text-foreground/80 leading-relaxed text-base font-default px-4 md:px-[49px] md:text-lg">At God Father Company, we believe that luxury is defined by the details. Under the leadership of <br />Miguel Alonzo, our commitment to excellence ensures that every custom build and renovation meets the highest standards of architectural integrity. We source premium materials and employ master artisans to create spaces that are as durable as they are beautiful, providing our Austin clients with lasting value and peace of mind.</p>
          </div>
          
          <div className="flex flex-col gap-4">
            <h3 className="text-2xl md:text-3xl font-bold font-default text-foreground uppercase tracking-wider">   PROFESSIONAL RELIABILITY</h3>
            <p className="text-foreground/80 leading-relaxed text-base font-default px-4 md:px-5 w-full md:max-w-[500px] md:text-lg">
              Building a home is a significant journey, and we are dedicated to being 
              your most trusted partner. Our approach is rooted in transparency, 
              professionalism, and a relentless pursuit of perfection. From initial 
              consultation to the final walkthrough, we prioritize clear communication 
              and meticulous project management, ensuring your vision is realized 
              on schedule and with the sophistication your lifestyle demands.
            </p>
          </div>
        </div>

        <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681426/img/modern_farmhouse_collage.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681426/img/modern_farmhouse_collage.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681426/img/modern_farmhouse_collage.png-wvc-sizes" alt="Collage of modern farmhouse home with beautiful landscaping and a swim spa in the backyard" loading="lazy" decoding="async" className="w-full h-auto mb-20 lg:mb-32" />

        <h2 className="text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-bold font-default text-center text-foreground tracking-widest uppercase">PROUDLY SERVING <br />AUSTIN &amp; SURROUNDING AREAS</h2>
      </div>
    </section>;
}